<template>
  <section
    id="apply"
    class="bg-[#dff0d8] py-20"
  >
    <div class="co-container-sm mx-auto bg-co-gray-50 px-4 py-[3.25rem] shadow md:px-[3.25rem]">
      <h2 class="co-display-7 mb-4 text-center">
        {{ packTitle }}
        <br>
        お申し込み
      </h2>
      <div>
        <p class="mb-[3.25rem] text-center">
          <span class="inline md:block">
            <a
              href="/terms"
              target="_blank"
            >
              利用規約
            </a>に同意の上、下記フォームに内容を記入してお申し込みください。
          </span>
          <span class="inline md:block">
            お申し込み後、メールにて入金のご案内をお送り致します。
          </span>
        </p>
      </div>

      <!-- アラート -->
      <div
        v-show="showNotification"
        class="alert mb-4 block rounded border-[#ffeeba] bg-[#fff3cd] text-center text-[#856404]"
      >
        <FontAwesomeIcon
          :icon="faTriangleExclamation"
          class="fa-fw inline pr-2"
        />
        {{ showNotification }}
      </div>

      <TeSetApplyForm
        :pack="pack"
        :pack-plans="packPlans"
        :current-promotion="currentPromotion"
        :pack-screen-name="packScreenName"
        :entry-campaign="entryCampaign"
      />
    </div>
  </section>
</template>

<script lang="ts">
import TeCommonBannerTimeLimitCpnCode from '~/components/Te/TeCommon/Banner/TeCommonBannerTimeLimitCpnCode/TeCommonBannerTimeLimitCpnCode.vue'
import TeSetApplyForm from '~/components/Te/TeSet/TeSetApplyForm.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faTriangleExclamation } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

interface Props {
  pack: any
  packPlans: any
  currentPromotion: any
  packScreenName: string | null
}

const options = {
  async setup() {
    return {
      faTriangleExclamation,
    }
  },
  props: {
    pack: {
      default: null,
    },
    packPlans: {
      default: () => [],
    },
    currentPromotion: {
      default: null,
    },
    packScreenName: {
      type: String,
      default: null,
    },
    entryCampaign: {
      type: Object,
      default: null,
    },
  },
  computed: {
    packTitle(): string {
      return this.pack ? this.pack.attributes.track_title : '-'
    },
    fuelStartsAt(): Date | null {
      return this.pack ? new Date(this.pack.attributes.fuel_starts_at) : null
    },
    closesAt(): Date | null {
      return this.pack ? new Date(this.pack.attributes.closes_at) : null
    },
    showNotification(): string | null {
      if (this.closesAt) {
        const now = new Date()
        const leftDays =
          (this.closesAt.valueOf() - now.valueOf()) / (1000 * 60 * 60 * 24)
        if (leftDays > 0 && leftDays < 1) {
          return '本日締め切り！'
        } else if (this.fuelStartsAt && this.fuelStartsAt < now) {
          return '残りわずか！'
        } else {
          return null
        }
      } else {
        return null
      }
    },
  },
  components: {
    TeCommonBannerTimeLimitCpnCode,
    TeSetApplyForm,
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>
